<template>
  <div class="sm-adjust-history">
    <a
      href="#"
      class="sm-plan-details__link top"
      @click.prevent="$emit('back')"
    >Back to Plans & Billing</a>

    <h4>Adjustments History</h4>
    <table
      v-if="viewPort == 'large'"
      class="sm-table sm-adjust-history__table"
    >
      <thead class="sm-table__head">
        <tr class="sm-txt-upper">
          <th class="sm-table__head-item name">Transaction</th>
          <th class="sm-table__head-item description">Description</th>
          <th class="sm-table__head-item created">Created at</th>
          <th class="sm-table__head-item amount sm-txt-center">Credit</th>
          <th class="sm-table__head-item amount sm-txt-center">Debit</th>
          <th class="sm-table__head-item balance sm-txt-center">Balance</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in currentList"
          :key="item.id"
        >
          <td class="name">{{item.name}}</td>
          <td class="description">{{item.description}}</td>
          <td class="created">{{item.created_at | moment('D MMMM, YYYY')}}</td>
          <td class="amount sm-txt-center">{{item.adjustment_type == 'credit' ? formatPrice(item.adjustment_amount) : '-'}}</td>
          <td class="amount sm-txt-center">{{item.adjustment_type == 'debit' ? formatPrice(item.adjustment_amount) : '-'}}</td>
          <td class="balance sm-txt-center">{{formatPrice(item.balance)}}</td>
        </tr>
      </tbody>
    </table>
    <div
      v-else 
      class="sm-mobile-table sm-adjust-history__mobile-table"
    >
      <div class="sm-mobile-table-item header">
        <div class="sm-mobile-table-item-row">
          <div class="sm-mobile-table-item-row-th name">Transaction</div>
          <div class="sm-mobile-table-item-row-th sm-txt-center amount">Credit</div>
          <div class="sm-mobile-table-item-row-th sm-txt-center amount">Debit</div>
          <div class="sm-mobile-table-item-row-th sm-txt-center balance">Balance</div>
        </div>
      </div>
      <div 
        v-for="item in currentList"
        :key="item.id"
        class="sm-mobile-table-item"
        :class="item.itemOpen ? 'open' : ''"
      >
        <div class="sm-mobile-table-item-row">
          <div 
            class="sm-mobile-table-item-row-elem name"
            @click="toggleItem(item)"
          >
            <include-svg :name="'icon-arrow-b-bold'" />
            <span>{{item.name}}</span>
          </div>
          <div class="sm-mobile-table-item-row-elem sm-txt-center amount">{{item.adjustment_type == 'credit' ? formatPrice(item.adjustment_amount) : '-'}}</div>
          <div class="sm-mobile-table-item-row-elem sm-txt-center amount">{{item.adjustment_type == 'debit' ? formatPrice(item.adjustment_amount) : '-'}}</div>
          <div class="sm-mobile-table-item-row-elem sm-txt-center balance">{{formatPrice(item.balance)}}</div>
        </div>
        <ul class="sm-mobile-table-item-dropdown">
          <li>
            <span>Created at</span>
            <span>{{item.created_at | moment('D MMM, YYYY')}}</span>
          </li>
          <li>
            <span>Description</span>
            <span>{{item.description}}</span>
          </li>
        </ul>
      </div>
    </div>

    <btn-block 
      v-if="canShowMore"
      :type="'show'" 
      :text="'Show more'" 
      :icon="'icon-arrow-round'" 
      @click="$emit('get-more')"
    />
  </div>
</template>

<script>
import {FormatPrice} from '@/utils/general-data';
import ViewPort from '@/mixins/ViewPort';

export default {
  name: 'adjust-history',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    canShowMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentList: [],
      allowedBreakpoints: [
        'medium',
        'large'
      ],
    }
  },
  created() {
    this.prepareList();
  },
  methods: {
    formatPrice: FormatPrice,
    prepareList() {
      this.currentList = this.list.map(item => {
        return {
          ...item,
          itemOpen: false
        }
      })
    },
    toggleItem(item) {
      item.itemOpen = !item.itemOpen;
    },
  },
  mixins: [ViewPort],
  watch: {
    list() {
      this.prepareList();
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/components/account/_adjust-history.scss';
</style>